var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"my-16"},[_c('v-row',{attrs:{"dense":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-toolbar',{attrs:{"color":"primary"}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.parseAttribute('homePage.header_btn')))])],1)],1),_c('v-col',{attrs:{"cols":"12"}},[_c('guest-order-form')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }